<template>
  <VTBaseTemplate>
    <!-- MODALS -->
      <b-modal
        id="api-err-modal"
        v-model="apiErrModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Dataset Fetch Error"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="err_msg"></span>
        <!-- <b-button 
          class="mt-3" 
          :to="{name: vecdyn-datasets'}" 
          block
        >OK</b-button> -->
        <b-button 
          class="mt-3" 
          :to="{name: 'vecdyn-datasets'}" 
          block
        >OK</b-button>
      </b-modal>
      <b-modal
        v-model="embargoKeyModalShow"
        centered
        scrollable
        hide-footer
        title="Reset Embargo Key"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'"
      >
        <p>
          Are you sure you want to reset the Embargo Key for this dataset?<br>
          Note that any links previously shared will no longer work once the Embargo Key is reset.
        </p>
        <b-button class="mt-3" style="margin-right:20px; margin-left:100px;" @click="embargoKeyModalShow=false">
          Cancel
        </b-button>
        <b-button class="mt-3" variant='primary' @click="resetEmbargoKey">Reset Embargo Key</b-button>
      </b-modal>
      <!-- END MODALS -->
    <div class="w-100 h-100">
      <b-container fluid>
        <br><br><br>
        <h2 class="tw-mb-0 text-aegis-dk">Publication Information for Dataset: {{ id }}</h2>
      </b-container>
      <hr />
      <b-container 
        fluid 
        style="color: black; text-align: left; padding-left: 50px; padding-right: 50px;" 
        class="data-table" 
        v-if="data"
      >
        <b-row>
          <b-col md="12">
            <div>
              <!-- <h3>Publication Info ID: {{ publicationinfoid }}</h3> -->
              <form @submit.prevent="onSubmit" class="mt-3">
                <fieldset >
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">URL with Embargo Link</label>
                    <b-row class="col-sm-10">
                      <b-col cols="9" class="mt-2">
                        https://vectorbyte.crc.nd.edu/vecdyn-detail/{{ id }}/{{ embargo_key }}
                      </b-col>
                      <b-col cols="3">
                        <b-button 
                          variant="primary" 
                          @click="embargoKeyModalShow = true"
                          style="font-size: small; float: right;"
                        >Reset Embargo Key</b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Title</label>
                    <div class="col-sm-10">
                      <input v-model="title" class="form-control" type="text">
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Tag(s)</label>
                    <div class="col-sm-10">
                      <!-- Tags display and input -->
                      <div class="tags-container">
                        <!-- Display existing tags -->
                        <div v-if="tags && tags.length > 0" class="mb-2">
                          <span 
                            v-for="(tag, index) in tags" 
                            :key="index" 
                            class="badge badge-primary mr-1 mb-1"
                            style="font-size: 0.8em; cursor: pointer;"
                            @click="removeTag(index)"
                            title="Click to remove"
                          >
                            {{ tag }} ×
                          </span>
                        </div>
                        <!-- Input for new tag -->
                        <div class="input-group">
                          <input 
                            v-model="newTag" 
                            class="form-control" 
                            type="text" 
                            placeholder="Enter a tag and press Enter"
                            @keydown.enter.prevent="addTag"
                            @keydown="handleKeydown"
                          >
                          <div class="input-group-append">
                            <button 
                              class="btn btn-outline-secondary" 
                              type="button" 
                              @click="addTag"
                              :disabled="!newTag.trim()"
                            >
                              Add Tag
                            </button>
                          </div>
                        </div>
                        <small class="form-text text-muted">
                          Press Enter or comma to add a tag. Click on a tag to remove it.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">DOI</label>
                    <div class="col-sm-10">
                      <input v-model="doi" class="form-control" type="text">
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Citation</label>
                    <div class="col-sm-10">
                      <input v-model="citation" name="doi" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Description</label>
                    <div class="col-sm-10">
                      <input v-model="description" name="doi" class="form-control" type="text" >    
                    </div>
                  </div>
                  <!-- <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">URL</label>
                    <div class="col-sm-10">
                      <input v-model="description" name="url" class="form-control" type="text" >    
                    </div>
                  </div> -->
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Contact Name</label>
                    <div class="col-sm-10">
                      <input v-model="contact_name" name="contact_name" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Contact Affiliation</label>
                    <div class="col-sm-10">
                      <input v-model="contact_affiliation" name="contact_affiliation" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Email</label>
                    <div class="col-sm-10">
                      <input v-model="email" name="email" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Dataset License</label>
                    <div class="col-sm-10">
                      <input v-model="dataset_license" name="dataset_license" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Project Identifier</label>
                    <div class="col-sm-10">
                      <input v-model="project_identifier" name="project_identifier" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Publication Status</label>
                    <div class="col-sm-10">
                      <input v-model="publication_status" name="publication_status" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Data Rights</label>
                    <div class="col-sm-10">
                      <input v-model="data_rights" name="data_rights" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Embargo Release Date</label>
                    <div class="col-sm-10">
                      <input v-model="embargo_release_date" name="embargo_release_date" class="form-control" type="date">    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Data Set Type</label>
                    <div class="col-sm-10">
                      <input v-model="data_set_type" name="data_set_type" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Collection Author Name</label>
                    <div class="col-sm-10">
                      <input v-model="collection_author_name" name="collection_author_name" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Collection Author Description</label>
                    <div class="col-sm-10">
                      <input v-model="collection_author_description" name="collection_author_description" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Curated By Citation</label>
                    <div class="col-sm-10">
                      <input v-model="curatedbycitation" name="curatedbycitation" class="form-control" type="text">    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Curated By DOI</label>
                    <div class="col-sm-10">
                      <input v-model="curatedbydoi" name="curatedbydoi" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Submitted By</label>
                    <div class="col-sm-10">
                      <input v-model="submittedby" name="submittedby" class="form-control" type="text" >    
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="col-sm-2 control-label col-form-label">Contributor Email</label>
                    <div class="col-sm-10">
                      <input v-model="contributoremail" name="contributoremail" class="form-control" type="text" >    
                    </div>
                  </div>

                  <!-- <div class="row mb-3 horizontal-checkbox ">
                    <label class="col-sm-2 control-label col-form-label">Published</label>
                    <div class="col-sm-10">
                      <input v-model="published" type="checkbox" name="published" >
                    </div>
                  </div> -->
                  <div class="form-actions">
                    <router-link 
                      :to="{ name: 'vecdyn-detail', params: { id: this.id } }" 
                      class="btn btn-primary js-tooltip ml-1 button-link" 
                      style="float: right;"
                    >
                      Return to Dataset
                    </router-link>

                    <button 
                      type="submit"
                      class="btn btn-primary js-tooltip ml-1"
                      style="float: right;"
                      :class="{ 'btn-warning': hasUnsavedChanges }"
                      :title="hasUnsavedChanges ? 'You have unsaved changes' : ''"
                    >
                      {{ hasUnsavedChanges ? 'Save Changes *' : 'Save Changes' }}
                    </button>
                  </div>
                  
                </fieldset>
              </form>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </VTBaseTemplate>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import VTBaseTemplate from "@/layouts/VTBaseTemplate.vue";

export default {
  name: "citation-edit",
  mixins: [VTBaseTemplate],
  components: {
      VTBaseTemplate,
  },
  props: {
    id: {
      type: String,
      required: true
    },
  },
  data(){
    return{
      data: undefined,
      embargo_key: '',
      publicationinfoid: '',
      description: '',
      tags: [],
      newTag: '',
      // url: '',
      contact_name: '',
      contact_affiliation: '',
      email: '',
      dataset_license: '',
      project_identifier: '',
      publication_status: '',
      data_rights: '',
      embargo_release_date: '',
      data_set_type: '',
      collection_author_name: '',
      collection_author_description: '',
      curatedbycitation: '',
      curatedbydoi: '',
      submittedby: '',
      contributoremail: '',
      err_msg: '',
      apiErrModalShow: false,
      doiErrModalShow: false,
      embargoKeyModalShow: false,
      // Store original values for change tracking
      originalData: {},
    };
  },
  computed: {
    // Check if there are any unsaved changes
    hasUnsavedChanges() {
      const changedFields = this.getChangedFields();
      return Object.keys(changedFields).length > 0;
    }
  },
  watch: {},
  created() {
    document.title = "Citation for Dataset " + this.id;
    this.getData();
    this.getEmbargoKey();
  },
  methods: {
    hideDoiModal() {
      this.doiErrModalShow = false;
    },
    // Tag management methods
    addTag() {
      const tag = this.newTag.trim();
      if (tag && !this.tags.includes(tag)) {
        this.tags.push(tag);
        this.newTag = '';
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    handleKeydown(event) {
      if (event.key === ',') {
        event.preventDefault();
        this.addTag();
      }
    },
    // Store original data for change tracking
    storeOriginalData() {
      this.originalData = {
        title: this.title,
        tags: JSON.parse(JSON.stringify(this.tags)), // Deep copy of array
        doi: this.doi,
        citation: this.citation,
        description: this.description,
        contact_name: this.contact_name,
        contact_affiliation: this.contact_affiliation,
        email: this.email,
        dataset_license: this.dataset_license,
        project_identifier: this.project_identifier,
        publication_status: this.publication_status,
        data_rights: this.data_rights,
        embargo_release_date: this.embargo_release_date,
        data_set_type: this.data_set_type,
        collection_author_name: this.collection_author_name,
        collection_author_description: this.collection_author_description,
        curatedbycitation: this.curatedbycitation,
        curatedbydoi: this.curatedbydoi,
        submittedby: this.submittedby,
        contributoremail: this.contributoremail,
      };
    },
    // Get only changed fields
    getChangedFields() {
      const changedFields = {};
      
      // Helper function to compare values (handles arrays and null/undefined)
      const hasChanged = (current, original) => {
        if (Array.isArray(current) && Array.isArray(original)) {
          return JSON.stringify(current.sort()) !== JSON.stringify(original.sort());
        }
        return current !== original;
      };
      
      // Check each field for changes
      const fieldsToCheck = [
        'title', 'doi', 'citation', 'description', 'contact_name', 
        'contact_affiliation', 'email', 'dataset_license', 'project_identifier',
        'publication_status', 'data_rights', 'embargo_release_date', 'data_set_type',
        'collection_author_name', 'collection_author_description', 'curatedbycitation',
        'curatedbydoi', 'submittedby', 'contributoremail'
      ];
      
      fieldsToCheck.forEach(field => {
        if (hasChanged(this[field], this.originalData[field])) {
          changedFields[field] = this[field];
        }
      });
      
      // Handle tags separately since it's an array
      if (hasChanged(this.tags, this.originalData.tags)) {
        changedFields.tags = this.tags;
      }
      
      return changedFields;
    },
    getData() {
      return HTTP.get(`/api/publication-info/${this.id}`)
      .then(response => {
        this.data = response.data
        this.publicationinfoid = response.data['publicationinfoid']
        this.title = response.data['title']
        // Handle tags as array - ensure it's always an array
        this.tags = Array.isArray(response.data['tags']) ? response.data['tags'] : []
        this.doi = response.data['doi']
        this.citation = response.data['citation']
        this.description = response.data['description']
        this.contact_name = response.data['contact_name']
        this.contact_affiliation = response.data['contact_affiliation']
        this.email = response.data['email']
        this.dataset_license = response.data['dataset_license']
        this.project_identifier = response.data['project_identifier']
        this.publication_status = response.data['publication_status']
        this.data_rights = response.data['data_rights']
        this.embargo_release_date = response.data['embargo_release_date']
        this.data_set_type = response.data['data_set_type']
        this.collection_author_name = response.data['collection_author_name']
        this.collection_author_description = response.data['collection_author_description']
        this.curatedbycitation = response.data['curatedbycitation']
        this.curatedbydoi = response.data['curatedbydoi']
        this.submittedby = response.data['submittedby']
        this.contributoremail = response.data['contributoremail']
        
        // Store original values for change tracking
        this.storeOriginalData();
      })
      .catch(error => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
      });
    },
    onSubmit(){
      this.editPublicationInfo()
    },
    getEmbargoKey() {
      return HTTP.get(`/api/vecdyn-get-embargo-key/${this.id}`)
      .then(response => {
        this.embargo_key = response.data['embargo_key'];
      })
      .catch(error => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
      });
    },
    resetEmbargoKey() {
      return HTTP.get(`/api/vecdyn-reset-embargo-key/${this.id}`)
      .then(response => {
        this.embargo_key = response.data['embargo_key'];
        this.embargoKeyModalShow = false;
      })
      .catch(error => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.embargoKeyModalShow = false;
        this.apiErrModalShow = true;
      });
    },
    editPublicationInfo() {
      // Get only the fields that have changed
      const changedFields = this.getChangedFields();
      
      // Check if there are any changes
      if (Object.keys(changedFields).length === 0) {
        this.$notify({
          text: "No changes detected. Nothing to save.",
          duration: 5000,
          type: "info",
        });
        return;
      }
      
      // Prepare JSON payload with only changed fields (use PATCH for partial updates)
      const payload = {};
      
      // Add changed fields to payload
      Object.keys(changedFields).forEach(field => {
        const value = changedFields[field];
        // Handle tags as array (Django expects array, not JSON string)
        if (field === 'tags') {
          payload.tags = value; // Send as array directly
        } else {
          payload[field] = value;
        }
      });

      // Remove null values from payload
      Object.keys(payload).forEach(key => {
        if (payload[key] === null || payload[key] === undefined) {
          delete payload[key];
        }
      });

      // Use PATCH instead of PUT for partial updates
      HTTP.patch(`/api/publication-info/${this.id}/`, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => { 
          this.err_msg = response.data.err_msg;
          this.$notify({
            text: "Publication successfully updated!",
            duration: 10000,
            type: "success",
          });
          // Update original data after successful save
          this.storeOriginalData();
      })
      .catch(error => {
          this.err_msg = HandleErrors.HandleErrors(error);
          this.apiErrModalShow = true;
      });
    },
  },
};
</script>

<style scoped>
    h1, h2, h3, h4, a, p, text, label, table {
        color: black !important;
        text-shadow: none;
    }

    .button-link {
      color: white !important;
    }

    .data-table .data-table-row:nth-child(even){
        background-color: #CFD5E9;
    }
    .data-table .data-table-row:nth-child(odd){
        background-color: #E9EBF4;
    }
    .data-table .data-table-row{
        border-top: 2px solid white;
    }

    .unplottable {
      color: red !important;
    }

    .vertical-center {
      margin: 0;
      position: absolute;
      top: 50%;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }

    .well {
      min-height: 20px;
      padding: 19px;
      margin: 6px;
      margin-bottom: 20px;
      background-color: #f5f5f5;
      border: 1px solid #e3e3e3;
      border-radius: 4px;
    }

    /* Tags styling */
    .tags-container .badge {
      display: inline-block;
      padding: 0.25em 0.4em;
      font-size: 0.75em;
      font-weight: 700;
      line-height: 1;
      text-align: center;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 0.25rem;
      background-color: #007bff;
      color: #fff;
      transition: background-color 0.15s ease-in-out;
    }

    .tags-container .badge:hover {
      background-color: #dc3545;
    }

    .tags-container .input-group {
      margin-top: 0.5rem;
    }

</style>